declare var DEPLOY_URL: any;
declare var IS_MOBILE: any;

export default {
    DEPLOY_URL: DEPLOY_URL || '',
    IS_MOBILE: IS_MOBILE || '',
};
